import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, accountNumber] as const

export type gdcoCredType = (typeof credentialTypes)[number]
export const gdcoDocumentTypes = [
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const gdco: CarrierDef<gdcoCredType> = {
  name: 'GLS Canada',
  scac: 'gdco',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'accountNumber'], //For engine api
  ],
  engineLayers: ['documents'],
  documentTypes: gdcoDocumentTypes,
  credentialConfig: {
    username: { hideFromFreightview: true },
    password: { hideFromFreightview: true },
    'account-number': { customerIdentifier: true },
  },
}
